import { QueryClientProvider } from '@tanstack/react-query';
import { ThemeProvider } from 'next-themes';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Toaster } from 'sonner';
import { App } from './App';
import { queryClient } from './lib/query-client';
import './index.css';


createRoot(document.getElementById('root')!).render(
	<StrictMode>
		<ThemeProvider attribute="class" defaultTheme="dark" enableSystem={false}>
			<QueryClientProvider client={queryClient}>
				<App />
				<Toaster
					position="bottom-right"
					toastOptions={{
						style: {
							background: 'var(--color-card)',
							border: '1px solid var(--color-border)',
							color: 'var(--color-text-primary)',
						},
					}}
				/>
			</QueryClientProvider>
		</ThemeProvider>
	</StrictMode>,
);
